var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C1.44772 7 1 7.44772 1 8V32C1 32.5523 1.44772 33 2 33H5V36C5 36.5523 5.44772 37 6 37H9V40C9 40.5523 9.44771 41 10 41H46C46.5523 41 47 40.5523 47 40V16C47 15.4477 46.5523 15 46 15H43V12C43 11.4477 42.5523 11 42 11H39V8C39 7.44772 38.5523 7 38 7H2ZM37 11V9H3V31H5V12C5 11.4477 5.44772 11 6 11H37ZM41 15V13H7V35H9V16C9 15.4477 9.44771 15 10 15H41ZM11 34.4142V39H45V34.4142L34 23.4142L22.7071 34.7071C22.3166 35.0976 21.6834 35.0976 21.2929 34.7071L16 29.4142L11 34.4142ZM11 31.5858L15.2929 27.2929C15.6834 26.9024 16.3166 26.9024 16.7071 27.2929L22 32.5858L33.2929 21.2929C33.6834 20.9024 34.3166 20.9024 34.7071 21.2929L45 31.5858V17H11V31.5858ZM19 21C17.8954 21 17 21.8954 17 23C17 24.1046 17.8954 25 19 25C20.1046 25 21 24.1046 21 23C21 21.8954 20.1046 21 19 21ZM15 23C15 20.7909 16.7909 19 19 19C21.2091 19 23 20.7909 23 23C23 25.2091 21.2091 27 19 27C16.7909 27 15 25.2091 15 23Z",
    fill: "#4480AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.8fbc7c20bec0d69d0623857f5276baab.svg";
export { ForwardRef as ReactComponent };